/**
 * Предпочтение «меньше движения»: при нём анимации не играются вовсе —
 * результат показывается сразу (DESIGN-SYSTEM.md, «Reduced motion»).
 */
export function prefersReducedMotion(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
